import axios from './axios'

class AuthRepository {
  register (data) {
    return axios.post(`/users`, data).then((response) => {
      return response.data
    })
  }

  login (email, pw) {
    return axios
      .post(`/users/signin`, {
        email: email,
        password: pw
      })
      .then((response) => {
        return response.data
      })
  }

  get (token) {
    return axios.get(`/users?token=${token}`).then((response) => {
      return response.data
    })
  }

  save (user) {
    // const token = localStorage.getItem("sts_token");
    return axios.put(`/users/${user.id}`, user).then((response) => {
      return response.data
    })
  }

  changePassword (obj) {
    return axios.put(`/changePassword/${obj.id}`, obj).then((response) => {
      return response.data
    })
  }

  resetPassword (email) {
    return axios
      .post(`/users/resetpassword`, { email: email })
      .then((response) => {
        return response.data
      })
  }
}

export default new AuthRepository()



// WEBPACK FOOTER //
// ./src/data/auth.repository.js